// We need a global, single value flag that we can check in window.onbeforeunload and beforeRouteLeave
// BUT we also need to be able to bind to a reactive property within the components!
// We can't really use Vuex (store) becuase that needs access to a component so the only
// way I can see is to have TWO flags - one here and one as a property on the current
// component, both with the same value :-(

// TODO - think up a better way!?

let myIsDirty = false;
let cleanFingerprint: string = "";

const isDebug = false;

export interface IDirtynessOptions {
    model: any;
    isDeep: boolean;
    excludeList: Array<string>
}

/* tslint:disable:no-bitwise */
function getHash(str: string, seed: number = 0): number {
    // from https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
    let h1 = 0xdeadbeef ^ seed,
      h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
      ch = str.charCodeAt(i);
      h1 = Math.imul(h1 ^ ch, 2654435761);
      h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}

// this makes arrays that are the same but in different order, different!
function buildFingerprintArray(model: any, isDeep: boolean, excludeList: Array<string>, values: Array<any>)  {
    if(model == null) return "";

    for (const key in model) {
        if (!model.hasOwnProperty(key) || excludeList.indexOf(key) !== -1) continue;
        const item = model[key];
        
        if(item == null) {
            //values.push(key + "=NULL");
            values.push(null);
        }
        else if (isDeep && typeof item === "object" && key.substring(0, 1) !== "_") {
            buildFingerprintArray(item, isDeep, excludeList, values);
        }
        else if (Array.isArray(item)) {
            for (let i = 0; i < item.length; i++) {
                buildFingerprintArray(item[i], isDeep, excludeList, values);
            }
        }
        else if(typeof item !== "object") {
            //values.push(key + "=" + item.toString());
            values.push(item);
        }
    }
}

function getFingerPrint(model: any, isDeep: boolean, excludeList: Array<string>): string {
    const fingerprintArray: Array<any> = [];
    buildFingerprintArray(model, isDeep, excludeList, fingerprintArray);
    const fingerPrint = fingerprintArray.join("|");
    return isDebug 
        ? fingerPrint
        : String(getHash(fingerPrint));
}

const dirtyness = {
    get isDirty(): boolean {
        return myIsDirty;
    },
    // call this after load or save 
    setClean(options: IDirtynessOptions): boolean {
        cleanFingerprint = getFingerPrint(options.model, options.isDeep, options.excludeList);
        myIsDirty = false;
        return myIsDirty;
    },
    // call this whenever anything changes (use a watcher)
    dataChanged(options: IDirtynessOptions): boolean {
        const fingerprint = getFingerPrint(options.model, options.isDeep, options.excludeList);
        myIsDirty = fingerprint !== cleanFingerprint;
        if(isDebug) {
            console.log("💩 current:", fingerprint.replace(/(?:\r\n|\r|\n)/g, "¬"));
            console.log("💩 clean  :", cleanFingerprint.replace(/(?:\r\n|\r|\n)/g, "¬"));
            console.log("💩 dirty? :", myIsDirty);    
        }
        return myIsDirty;
    },
    // call this when we navigate away and abandon changes
    reset(): boolean {
        cleanFingerprint = "";
        myIsDirty = false;
        return myIsDirty;
    },
    defaultAuditFieldList(): Array<string> {
        return ["created", "createdByUserID", "lastUpdated", "lastUpdatedByUserID", "deleted", "deletedByUserID"];
    }

};

export default dirtyness;